import React from 'react';

const barStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '4px',
  background: 'rgba(93,194,241,0.15)',
  zIndex: 2,
  overflow: 'hidden',
};

const progressStyle = (percent = 50) => ({
  width: `${percent}%`,
  height: '100%',
  borderRadius: '2px',
  background: 'linear-gradient(270deg, #3b82f6, #90b2f9, #3b82f6)',
  backgroundSize: '400% 100%',
  animation: 'progressBarMove .8s linear infinite',
});

const keyframes = `
@keyframes progressBarMove {
  0% { background-position: 400% 0; }
  100% { background-position: 0 0; }
}
`;

const LoadingProgressBar = ({ percent = 50, loading = true }) => {
  const [progress, setProgress] = React.useState(percent);

  React.useEffect(() => {
    if (!document.getElementById('progress-bar-keyframes')) {
      const style = document.createElement('style');
      style.id = 'progress-bar-keyframes';
      style.innerHTML = keyframes;
      document.head.appendChild(style);
    }
  }, []);

  React.useEffect(() => {
    setProgress(percent);
  }, [percent]);

  React.useEffect(() => {
    if (!loading) {
      setProgress(percent);
      return;
    }

    setProgress((prev) => Math.max(prev, 50));

    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 99) {
          return 99;
        }
        return prev + 1;
      });
    }, 80);

    return () => clearInterval(interval);
  }, [loading, percent]);

  if (!loading) return null;

  return (
    <div style={barStyle}>
      <div style={progressStyle(progress)} />
    </div>
  );
};

export default LoadingProgressBar;
